import { Link } from 'react-router-dom';
import IdeaStatusBadge from './IdeaStatusBadge';

const statusBorderColor = {
  draft: 'border-l-gray-300',
  developing: 'border-l-blue-400',
  ready: 'border-l-green-400',
  published: 'border-l-purple-400',
  archived: 'border-l-yellow-400',
};

export default function IdeaCard({ idea }) {
  const timeAgo = (dateStr) => {
    const diff = Date.now() - new Date(dateStr).getTime();
    const mins = Math.floor(diff / 60000);
    if (mins < 60) return `${mins}m ago`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    return `${days}d ago`;
  };

  return (
    <Link
      to={`/ideas/${idea.id}`}
      className={`block bg-white dark:bg-gray-900 rounded-xl p-4 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 border border-gray-100 dark:border-gray-800 border-l-4 ${statusBorderColor[idea.status] || 'border-l-gray-300'}`}
    >
      <div className="flex items-start justify-between gap-2">
        <h3 className="font-medium text-gray-900 dark:text-white line-clamp-2">
          {idea.title || 'Untitled idea'}
        </h3>
        <IdeaStatusBadge status={idea.status} />
      </div>
      <p className="mt-2 text-sm text-gray-600 dark:text-gray-400 line-clamp-3">{idea.raw_input}</p>
      <div className="mt-3 flex items-center gap-2 text-xs text-gray-400 dark:text-gray-500">
        <span>{timeAgo(idea.updated_at)}</span>
        {idea.tags?.length > 0 && (
          <>
            <span>·</span>
            {idea.tags.slice(0, 3).map((tag) => (
              <span key={tag} className="bg-gray-100 dark:bg-gray-800 px-2 py-0.5 rounded">
                {tag}
              </span>
            ))}
          </>
        )}
      </div>
    </Link>
  );
}
